/*
 * @Description: 禁止微信反弹惯性
 * @Author: 蔺晨
 * @Date: 2021-01-27 17:45:08
 * @Last Modified time: 2021-01-27 17:45:08
 */

import React, { Component } from 'react';
import './index.less';

export default class ForbidReboundView extends Component {
  constructor(props, context) {
    super(props, context);
    this.forbidReboundRef = null;
    this.scrollViewDom = null;
    this.bodyDom = null;
  }

  componentDidMount() {
    let { name } = this.props;
    this.scrollViewDom = this.forbidReboundRef.getElementsByClassName(
      name || 'am-list-view-scrollview'
    )[0];
    this.bodyDom = document.getElementsByTagName('body')[0];
    this.scrollViewDom.addEventListener('touchstart', this.overScrollTouchStart);
    this.bodyDom.addEventListener('touchmove', this.overScrollTouchMove);
  }

  componentWillUnmount() {
    this.scrollViewDom.removeEventListener('touchstart', this.overScrollTouchStart);
    this.bodyDom.removeEventListener('touchmove', this.overScrollTouchMove);
  }

  overScrollTouchStart = (el) => {
    const { scrollTop, offsetHeight, scrollHeight } = this.scrollViewDom;
    if (scrollTop == 0) {
      this.scrollViewDom.scrollTo(0, 1);
      // 兼容小数精度
    } else if (Math.abs(scrollTop + offsetHeight - scrollHeight) < 1) {
      this.scrollViewDom.scrollTo(0, scrollTop - 1);
    }
  };

  overScrollTouchMove = (el) => {
    if (el.offsetHeight < el.scrollHeight) evt._isScroller = true;
  };

  render() {
    return (
      <div
        className="forbid-rebound"
        ref={(ref) => {
          this.forbidReboundRef = ref;
        }}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/ForbidRebound/index.js